import {Anchor, Button, Dialogue, Icon, Modal, Text} from '@albert-io/atomic';
import React, {useState} from 'react';

import constants from 'client/constants';

const CopyrightModal = () => {
  const [showCopyrightModal, setShowCopyrightModal] = useState(false);

  return (
    <>
      <Button
        size='s'
        roundness='pill'
        onClick={() => setShowCopyrightModal(true)}
        color='secondary'
        variant='text'
        className='u-margin-inline_auto u-margin-block_space-x5 !block'
      >
        <Text className='u-font-weight_normal' size='s' color='tertiary'>
          {`Copyright ${new Date().getFullYear()} Learn By Doing, Inc.`}{' '}
          <Icon icon={['far', 'info-circle']} className='u-margin-inline-start_space-x0-half' />
        </Text>
      </Button>
      {showCopyrightModal && (
        <Modal
          ariaLabel='Copyright information for Albert.io'
          handleClose={() => setShowCopyrightModal(false)}
        >
          {({CloseButtonWrapper, modalContentStyle}) => {
            return (
              <Dialogue inModal hideCloseBtn paddingLevel={4} className={modalContentStyle}>
                <Dialogue.Body className='u-gap_space-x5 flex flex-col items-start'>
                  <Icon icon={['fal', 'info-circle']} className='fa-2x' color='tertiary' />
                  <Text bold>{`Copyright ${new Date().getFullYear()} Learn By Doing, Inc.`}</Text>
                  <Text as='p' size='m'>
                    {constants.FULL_DISCLAIMER}
                  </Text>
                  <Text as='p' size='m' color='tertiary'>
                    <Anchor href='/privacy' className='content-secondary'>
                      Privacy Policy
                    </Anchor>
                    <Anchor href='/terms-of-use' className='u-mar-l_2 content-secondary'>
                      Terms of Use
                    </Anchor>
                  </Text>
                  <CloseButtonWrapper>
                    <Button
                      variant='outlined'
                      color='secondary'
                      onClick={() => setShowCopyrightModal(false)}
                      className='u-width_100pc'
                    >
                      Dismiss
                    </Button>
                  </CloseButtonWrapper>
                </Dialogue.Body>
              </Dialogue>
            );
          }}
        </Modal>
      )}
    </>
  );
};

export default CopyrightModal;
